/*
 Browse

 Rezerwacje - z wykorzystaniem Redux (implementacja w appredux)
 Stan nawigacji: (store.pageState)
 Wywołanie akcji: ??store.dispatch(??
   Actions.nazwaAkcj(<parametry>));

 do zrobienia:
  - logowanie

 historia: 
  04-2019 JW - start
  03-05-2019 - połączenie z Redux
  20-05-209 - materialize
*/

import * as React from "react";

import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import CardMedia from '@material-ui/core/CardMedia';
import { Grid, Fab } from '@material-ui/core';

import { AppState, Actions, store, PanelState, IPageState, DisplayWindow } from '../appredux';

import { connect } from 'react-redux';

import Browse from './Browse';
import Loader from './Loader';
import PanelRightBasket from './PanelRightBasket';
import PanelLeftTest from './PanelLeftTest';

import { Kontakt, hotelService, PortalInfo, Info, AsortMenuWiersze, AsortMenuWiersz, AsortGrupyWiersz, WWWSprzedazInfo, telefonService } from '../api';
import { MenuService, RestaurantService } from '../api';

import { Trans, WithTranslation, withTranslation } from 'react-i18next';

import CONFIG from '../cfg/config';

import { mobileBreakpoint } from './common/formFields/formularzStaleWspolne';

import Success from './components/Success';
import Failure from './components/Failure';
import { dostepnePrioryety, sendErrorLog } from "./common/helpers";
import MapContainer from "./map/MapContainer";
//import Historia from "./historia/Historia";
import Main from "./historia/Main";
import PanelRight from "./PanelRight";

import { MapData } from 'app/map_new/MapContainer';
import { gpsToNumber } from 'app/map_new/Distance';
import ResponsiveImgMaterialUi from "responsive-img-material-ui";
import LogoFooter from "./components/LogoFooter";

//PM 2021-11-03
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface BookingProps {
  //t?: any,
 page: IPageState
}

//PM 2021-03-17
interface BookingState {
  ready: boolean,
  width: number,
  //openLoad: boolean,
  openStatus: boolean,
  full: number,
  completed: number,
  ip: string,
  error: boolean,
  headersIds: number[],
  headers: AsortMenuWiersz[],

  openSuccess: boolean,
  openFailure: boolean,
}

class Booking extends React.Component<WithStyles<typeof styles> & BookingProps & WithTranslation, BookingState>  {

  constructor(props: WithStyles<typeof styles> & BookingProps & WithTranslation) {
    super(props, {});
    sessionStorage.setItem('operator_id', "1");
    this.state = {
      ready: false,
      width: window.innerWidth,
      //openLoad: true,
      openStatus: false,
      full: 5,
      completed: 0,
      ip: "---",
      error: false,
      headersIds: [],
      headers: [],

      openSuccess: CONFIG.stanPlatnosci === "ok" ? true : false,
      openFailure: CONFIG.stanPlatnosci === "notOk" ? true : false,
    }
  }

  pending: boolean = true
  logoUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/logo.png`
  grafikaUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/grafika.png`
  //logoUrl : string = `${CONFIG.apiURL}/hotel/img/logo1?hotelId=${CONFIG.hotelID}`

  //PM 2021-11-09
  //wyrzucenie await
  async componentDidMount() {
    this.updateWindowWidth();
    window.addEventListener('resize', this.updateWindowWidth);
    this.pending = false;
    // this.getIp()
    //this.getRestaurant() 
    await this.getMenuData();
    this.getHeadersData()
    this.getData();
    this.getInfo();
    await this.getFonts()
    this.getKontakt();
    await this.getPanelData()
    this.getTelefony()
  }

  closeWindows = () => {
    this.setState({ openSuccess: false, openFailure: false })
  }


  updateWindowWidth = () => {
    this.setState({ ...this.state, width: window.innerWidth });
    //this.width = window.innerWidth
  }

  shouldComponentUpdate() {
    //vscTest
    //console.log('shouldComponentUpdate')

    if (this.pending) return true
    else return false
  }

  componentDidUpdate(prevProps: BookingProps) {
    if (this.state.completed >= this.state.full && this.props.page.displayWindow === DisplayWindow.Loading) {
      setTimeout(() => {
        //this.setState({ ...this.state, openLoad: false });
        store.dispatch(Actions.pageState.setDisplayWindow(DisplayWindow.Main))       
      }, 600);
    }
  }

  closeDialogStatus = () => {
    this.setState({ openStatus: false })
  };

  async getIp() {
    try {
      let response = await fetch('https://api.ipify.org?format=json')
      let jsonData = await response.json()
      if (jsonData.ip !== undefined && jsonData.ip !== "")
        this.setState({ ...this.state, ip: jsonData.ip });
    } catch (error) {
      console.error(error)
    }
  }

  //PM 2021-11-09
  setError = () => {
    this.setState({ error: true });
    this.pending = true
  }

  getTelefony = async() => {
    try {
      let res = await telefonService.dajCzarnaListe( {}, {} )
      store.dispatch(Actions.pageState.setCzarnaLista(res.result))
  
    } catch (error) {
        sendErrorLog("0", "-1", 'vscSms/sms/dajSmsCzarnaListe')
        await store.dispatch(Actions.pageState.addFcmLogMessage("vscSms/sms/dajSmsCzarnaListe", 2))
        console.log(error);
    }

    try {
      let res1 = await telefonService.dajSmsGsmPlPrefiksy( {}, {} )
      res1.result = res1.result.map(x => ({...x, prefiks: x.prefiks[0] === "+" ? x.prefiks.substring(1) : x.prefiks }))
      store.dispatch(Actions.pageState.setPrefiksyPl(res1.result))
  
    } catch (error) {
        sendErrorLog("0", "-1", 'vscSms/sms/dajSmsGsmPlPrefiksy')
        await store.dispatch(Actions.pageState.addFcmLogMessage("vscSms/sms/dajSmsGsmPlPrefiksy", 2))
        console.log(error);
    }
  }

  //PM 2021-11-09
  //this.setError()
  async getPanelData() {

    try {
      let res: Info = await hotelService.getPortalInfo({
        hotelId: CONFIG.hotelID,
        //operatorId: Number(sessionStorage.getItem("operator_id")),
        domena: this.props.page.lang
      }, {})
      //console.log(res.result[0])
      //res.result[0].pay_web = "0"

      //aktualne pay_web
      //0/1/2/3
      //brak/P24/CashBill/SmsKod

      //console.log(res.result[0])
      await store.dispatch(Actions.pageState.setContact(res));

      //51.0443566N 20.9925000E
      //51.64041N 15.13140E
      //50.0209013989099, 22.011162790995158E
      //res.kontaktGps = "50.020901N 22.011162E"

      let gpsReturn = gpsToNumber(res.kontaktGps);
      let latNumber = gpsReturn.lat;
      let lngNumber = gpsReturn.lng;
      let d = new MapData({ obiektGPS: res.kontaktGps, obiektLat: latNumber, obiektLng: lngNumber })
      store.dispatch(Actions.pageState.setMap(d));


    } catch (error) {
      console.log(error)
      await sendErrorLog( "0", "-1", '/obiekt/dajPortalInfo')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/obiekt/dajPortalInfo", 2))
      this.setError();

    }
  }

  // async getLogo() { 
  //   console.log(CONFIG.hotelID)
  //   await RestaurantService.getLogo({ hotelId: CONFIG.hotelID, aOperatorId: Number(sessionStorage.getItem("operator_id")) }, {})
  //     .then(
  //       (res : any) => {
  //         console.log(res)
  //         console.log(res.result)

  //         }
  //       )        
  //     .catch( (err : any) => {
  //       console.error
  //       } 
  //     );
  // }

  // async getRestaurant() {
  //   await RestaurantService.getRestaurant({ hotelId: CONFIG.hotelID, aOperatorId: Number(sessionStorage.getItem("operator_id")) }, {})
  //     .then(
  //       (res: any) => {
  //         //console.log(res.result)

  //       }
  //     )
  //     .catch((err: any) => {
  //       console.log(err)
  //     }
  //     );
  // }

  //PM 2021-11-09
  //this.setError()
  async getInfo () {
    // const data = {"www_sprzedaz_odswiez_dane":1,
    // "www_sprzedaz_zamkniecieAuto":1,
    // "www_sprzedaz_operator_id":1,
    // "www_sprzedaz_kwota_limit_max":100,
    // "www_sprzedaz_kwota_limit_min":10,
    // "www_sprzedaz_ilosc_limit":15,
    // "www_sprzedaz_sposob_zaplaty":"GW",
    // "www_sprzedaz_error":1,
    // "www_sprzedaz_error_info": "zapraszamy w godz od 9 do 16",
    // "www_sprzedaz_czas_oczekiwania":60,
    // "www_sprzedaz_czas_oczekiwania_info":"od 60 - 90 min",
    // "dane_aktualizacja_dt":"2020-05-06/16:31:22",
    // "dane_aktualizacja_co":1,
    // ip: this.state.ip
    // }
    //store.dispatch(Actions.pageState.getInfo(data));
    RestaurantService.getInfo({ hotelId: CONFIG.hotelID, aOperatorId: Number(sessionStorage.getItem("operator_id")) }, {})
      .then(
        (res) => {
          //console.log(res.result)
          this.setState({ ...this.state, openStatus: res.result[0].www_sprzedaz_error === 0 ? false : true });
          //console.log({...res.result[0], ip: this.state.ip, })
          store.dispatch(Actions.pageState.getInfo({ ...res.result[0], ip: this.state.ip }));
        }
      )
      .catch((err: any) => {
        console.log(err)
        sendErrorLog( "0", "-1", '/manager/dajWwwSprzedazInfo')
        store.dispatch(Actions.pageState.addFcmLogMessage("/manager/dajWwwSprzedazInfo", 2))
        this.setError()

      }
      );
  }

  //PM 2021-11-09
  //this.setError()
  async getMenuData() {
    try {
      const res = await MenuService.getMenu({ hotelId: CONFIG.hotelID, aOperatorId: Number(sessionStorage.getItem("operator_id")) }, {})
      //console.log(res.result)
      await store.dispatch(Actions.pageState.getMenuItems(res.result));
      this.setState({ ...this.state, completed: this.state.completed + 1 });
    } catch (err) {
      console.log(err)
      await sendErrorLog( "0", "-1", '/manager/dajAsortWwwMenuNagl')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/dajAsortWwwMenuNagl", 2))
      this.setError()
    }
  }

  //PM 2021-11-09
  //this.setError()
  async getFonts() {
    try {
      const res = await RestaurantService.getFonts({ hotelId: CONFIG.hotelID, operatorId: Number(sessionStorage.getItem("operator_id")) }, {});
      //console.log(res)
      //jasno czerwony #F15347
      //ciemno czerwony #A43548
      //jasno fioletowy #653C98
      //ciemno fioletowy #26174E
      
      //res.result[2].color = "#653C98" //lewy
      //res.result[3].color = "#653C98"
      //res.result[4].color = "#653C98" //prawy
      //res.result[5].color = "#653C98"
      //res.result[6].color = "#653C98" //środkowy panel nagłówek
      await store.dispatch(Actions.pageState.setFonts(res.result));
    } catch (error) {
      console.log(error);
      await sendErrorLog( "0", "-1", '/manager/dajCzcionki')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/dajCzcionki", 2))
      this.setError();
    }
  }

  //PM 2021-11-09
  //this.setError()
  getHeadersData() {
    MenuService.getHeaders({ hotelId: CONFIG.hotelID, aOperatorId: Number(sessionStorage.getItem("operator_id")) }, {})
      .then(
        (res: AsortMenuWiersze) => {
          //console.log(res.result)
          res.result = res.result.map(x => ({...x, priorytet: !x.priorytet ||  x.priorytet === "0" ? "1" : x.priorytet    }))
         

          store.dispatch(Actions.pageState.getAsortHeaders(res.result));
          let priorytety = dostepnePrioryety(res.result, this.props.page.menuItems[0].menu_id)
         
          store.dispatch(Actions.pageState.setPriorytet(priorytety[0], priorytety[0], priorytety[priorytety.length - 1]));


          this.setState({ ...this.state, completed: this.state.completed + 1 });
        }
      )
      .catch((err: any) => {
        console.log(err)
        sendErrorLog( "0", "-1", '/manager/dajAsortWwwMenuWiersz')
        store.dispatch(Actions.pageState.addFcmLogMessage("/manager/dajAsortWwwMenuWiersz", 2))
        this.setError()
      }
      );
  }

  //PM 2021-11-09
  //this.setError()
  getData = () => {
    const id = this.props.page.selectedMenuItem;
    const data = this.props.page.asortHeaders.filter(e => e.menu_id === id);
    const ids: number[] = [];

    data.forEach(e => { ids.push(e.grupa_id) });
    this.setState({ headersIds: ids, headers: data, full: 2 + ids.length });

    let load = true;
    ids.forEach(e => {
      load = true;
      for (let i = 0; i < this.props.page.asort.length; i++) {
        if (this.props.page.asort[i][0].grupa_id === e) {
          load = false;
          break;
        }
      }
      if (load) {
        this.getAsortData(e);
      }
    });
    this.pending = true;
  };

  //PM 2021-11-09
  //this.setError()
  getAsortData = async(id: number) => {
    if(CONFIG.kelnerBookFoto === '0')
      try {
        let res = await MenuService.getAsort({ 
          hotelId: CONFIG.hotelID, 
          aOperatorId: Number(sessionStorage.getItem("operator_id")), 
          aGrupaId: id 
        }, {})

        store.dispatch(Actions.pageState.getAsort(res.result));
        this.setState({ ...this.state, completed: this.state.completed + 1 });
      
      } catch (error) {
          console.log(error)
          sendErrorLog( "0", "-1", '/manager/dajAsortWwwGrupyWiersz')
          store.dispatch(Actions.pageState.addFcmLogMessage("/manager/dajAsortWwwGrupyWiersz", 2))
          this.setError()
      }

    if(CONFIG.kelnerBookFoto === '1')
      try {
        let res = await MenuService.getAsortFoto({ 
          hotelId: CONFIG.hotelID, 
          aOperatorId: Number(sessionStorage.getItem("operator_id")), 
          aGrupaId: id 
        }, {})

        store.dispatch(Actions.pageState.getAsort(res.result));
        this.setState({ ...this.state, completed: this.state.completed + 1 });
      
      } catch (error) {
          console.log(error)
          sendErrorLog( "0", "-1", '/manager/dajAsortWwwGrupyWiersz')
          store.dispatch(Actions.pageState.addFcmLogMessage("/manager/dajAsortWwwGrupyWiersz", 2))
          this.setError()
      }
  
  }

  //PM 2021-11-09
  //this.setError()
  getKontakt() {
    MenuService.getKontakt({
      hotelId: CONFIG.hotelID,
      operatorId: Number(sessionStorage.getItem("operator_id")),
      domena: this.props.page.lang
    }, {})
      .then(
        (res: Kontakt) => {
          //console.log(res.result)
          store.dispatch(Actions.pageState.setKontakt(res.result));
        }
      )
      .catch((err: any) => {
        console.log(err)
        sendErrorLog( "0", "-1", '/manager/recepcjaDajWwwPortalInfo0')
        store.dispatch(Actions.pageState.addFcmLogMessage("/manager/recepcjaDajWwwPortalInfo0", 2))
        this.setError()
      }
      );
  }

  //PM 2021-11-03
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  selectComponent() {
    // const { t } = this.props;
    if (this.props.page.state === PanelState.psBrowse) {
      return (
        <Browse />
      )
      //   } else if  (this.props.page.state==PanelState.psUser) {
      //     if(this.props.page.display == 0 || this.props.page.display == 2){
      //       return (
      //         <div>
      //           <Browse />
      //           <ConfirmDialog  
      //               button = { t('Confirm Reservation') }
      //               fullScreen = {false}
      //               title = { t('Guest Details') }
      //               explanation = { t('Fill in the guest details') }
      //           />       
      //         </div>
      //       )   
      //      }  
      //   } else if  (this.props.page.state==PanelState.psUser2) {
      //     return ( 

      //       <div>
      //         <Browse />
      //         <ConfirmDialog2  
      //             button = { t('Confirm Reservation') }
      //             fullScreen = {false}
      //             title = { t('Guest Details') }
      //             explanation = { t('Fill in the guest details') }
      //         /> 
      //         {/* <Button onClick={ this.btnBrowseClick() }>{ 
      //           t('Confirm Reservation') }</Button> */}
      //       </div>
      //     )  
      //   }else if  (this.props.page.state==PanelState.psUser3) {
      //     return ( 

      //       <div>
      //         <Browse />
      //         <ConfirmDialog3  
      //             button = { t('Confirm Reservation') }
      //             fullScreen = {false}
      //             title = { t('Guest Details') }
      //             explanation = { t('Fill in the guest details') }
      //         /> 
      //         <Button >{ 
      //           t('Confirm Reservation') }</Button>
      //       </div>
      //     )  
      //   }else if  (this.props.page.state==PanelState.psUser4) {
      //     return ( 

      //       <div>
      //         <Browse />
      //         <ConfirmDialog4  
      //             button = { t('Confirm Reservation') }
      //             fullScreen = {false}
      //             title = { t('Guest Details') }
      //             explanation = { t('Fill in the guest details') }
      //         /> 
      //         {/* <Button onClick={ this.btnBrowseClick() }>{ 
      //           t('Confirm Reservation') }</Button> */}
      //       </div>
      //     )  
      //   }else if  (this.props.page.state==PanelState.psUser5) {
      //     return ( 

      //       <div>
      //         <Browse  />
      //         <ConfirmDialog5  
      //             button = { t('Confirm Reservation') }
      //             fullScreen = {false}
      //             title = { t('Guest Details') }
      //             explanation = { t('Fill in the guest details') }
      //         /> 
      //         {/* <Button onClick={ this.btnBrowseClick() }>{ 
      //           t('Confirm Reservation') }</Button> */}
      //       </div>
      //     )  
      //   }else if  (this.props.page.state==PanelState.psUser6) {
      //     return ( 

      //       <div>
      //         <Browse  />
      //         <NotifierNight  
      //             title = { t('Night session1') }
      //             messagePart1 = { t('Via phone') }
      //             messagePart2 = { t('In order to agree on the details') }
      //             color={"#458B00"}
      //             session={t('Please contact us')}
      //         /> 
      //         {/* <Button onClick={ this.btnBrowseClick() }>{ 
      //           t('Confirm Reservation') }</Button> */}
      //       </div>
      //     )  
      //   }else if  (this.props.page.state==PanelState.psUser7) {
      //     return ( 

      //       <div>
      //         <Browse />
      //         <ConfirmDialog7  
      //             button = { t('Confirm Reservation') }
      //             fullScreen = {false}
      //             title = { t('Guest Details') }
      //             explanation = { t('Fill in the guest details') }
      //         /> 
      //         {/* <Button onClick={ this.btnBrowseClick() }>{ 
      //           t('Confirm Reservation') }</Button> */}
      //       </div>
      //     )  
      //   } else if  (this.props.page.state==PanelState.psCalendar) {
      //     return (
      //         <Paper>
      //           <Browse  />
      //           <RCalendar />
      //         </Paper>     
      //     )  
    } else if (this.props.page.state === PanelState.psReservPending) {
      return (
        <Paper>
          <Browse />
          <Loader />
        </Paper>

      )
    }  //else if  (this.props.page.state==PanelState.psEndWindow) {
    //     return (
    //         <Paper>
    //           <Browse  />
    //           <Notifier messagePart1={t("Your reservation has number")} reservationNumber={ this.props.page.reservationId } messagePart2={t("Thank You for reservation. Confirmation has been sent to your e-mail address")} email={"jakiś email"} title={t("Confirmation")} color={"#458B00"} success={true}/>
    //         </Paper>     

    //     )  
    //   } else {
    //     return (
    //         <Browse  /> 
    //     )   
    //   }
  }

  closeError = () => {
    window.open('https://www.google.pl/', '_self');
  }

  logoClick = () => {
    window.open("http://virtualsc.com.pl/")
  }

  //PM 2021-11-03
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  //<PanelRight key={this.state.panelRightKey} incPanelRightKey={this.incPanelRightKey} />
  render = () => {
    //vscTest
    //console.log('render')
    const { classes } = this.props;
    //console.log(this.logoUrl)
    //console.log(this.props.page.kontakt)
    //console.log(this.props.page.contact)
    if (this.props.page.displayWindow === DisplayWindow.Loading) {
      return ( //ładowanie aplikacji
        <Grid container className={classes.container} >
          <Dialog
            disableEscapeKeyDown
            maxWidth="sm"
            open={true}
            fullWidth
          >
            <DialogContent>
              <DialogContentText
                className={classes.dialog} style={{ margin: "auto", textAlign: "center", fontSize: "1rem", padding: " 10px 0px 20px 0px" }} variant="h5" component="h2" color="primary"
              >
                <b>{"pobieranie danych..."}</b>
              </DialogContentText>
              {this.state.error ?
                <DialogContentText
                  className={classes.dialog} variant="h5" component="h2" color="primary" style={{ textAlign: "center", fontSize: "1rem", padding: " 10px 0px 20px 0px" }}
                >
                  <b>{"przepraszamy - brak połączenia z serwerem"}</b>
                </DialogContentText> : null}
              
              {/* <CardMedia
                //tclassName={classes.media}
                className={classes.image}
                image={this.logoUrl}
                style={window.innerWidth > 600 ? { width: '400px', height: '400px' } : { width: (window.innerWidth - 200) + 'px', height: (window.innerWidth - 200) + 'px' }}
              //title="logo"
              /> */}
              <div style={{ width: "fit-content", margin: 'auto', alignItems: "center", display: "flex" }}>
                <ResponsiveImgMaterialUi //style={{ width: "150px", padding: "1em 0px" }}
                  style={window.innerWidth > 600 ? { width: '400px', height: '400px' } : { width: (window.innerWidth - 200) + 'px', height: (window.innerWidth - 200) + 'px' }}
                  //xs={require('app/assets/logo-kulinarne-pysznosci.png').default}
                  //md={require('app/assets/logo-kulinarne-pysznosci.png').default}
                  //lg={require('app/assets/logo-kulinarne-pysznosci.png').default}
                  xs={this.logoUrl}
                  md={this.logoUrl}
                  lg={this.logoUrl}
                />
              </div>

            </DialogContent >
            {this.state.error ?
              <DialogActions className={classes.dialog} style={{}} >

                <Button onClick={() => this.closeError()} variant="outlined" size="small" color="primary"
                  style={{ textTransform: "none", fontSize: "0.8rem" }}
                >
                  <b><Trans>OK</Trans></b>
                </Button>

              </DialogActions> :
              <DialogActions className={classes.dialog} style={{ padding: "8px 25px 25px", display: "block" }} >
                <LinearProgress variant="determinate" value={this.state.completed / this.state.full * 100} />
              </DialogActions>}
          </Dialog>
        </Grid>
      )
    } else { //widok główny
      return (
        <Grid container className={classes.container} 
        style={this.props.page.displayWindow === DisplayWindow.Map? 
        {display: "block", padding: "10px 9px 7px 16px", maxWidth: "2000px"} : //mapa
        this.props.page.displayWindow === DisplayWindow.History ? 
        {display: "block", paddingTop: "0", maxWidth: "2000px"} :    //historia
        {display: "flex", padding: "2em 0px 0px 0px", maxWidth: "1340px"}}     //widok główny
        >    
          

          {/* ///////////////////////////////////////////////////////////////////////////////     */}
          {this.state.openStatus ?
            <Dialog
              disableEscapeKeyDown
              maxWidth="xs"
              open={this.state.openStatus}
              fullWidth
            >
              <DialogTitle disableTypography >
                {/* <Typography variant="h5" component="h2" color="primary" style={{paddingBottom: "10px"}}>
                 <b>{"Szanowny Kliencie"}</b>   
              </Typography>  */}
                <Typography variant="h5" component="h2" color="primary">
                  <b>{this.props.page.info.www_sprzedaz_error_info}</b>
                </Typography>
              </DialogTitle>
              <DialogContent style={{textAlign: "center"}} >
                {/* <div style={{margin: "1em auto auto", display: "flex"}}>
            <ResponsiveImgMaterialUi style={{height: "70%", width: "70%", margin: "auto"}} 
              xs={logoUrl}
              md={logoUrl}
              lg={logoUrl}
            /> 
            </div> */}
                {/* <CardMedia
                  //tclassName={classes.media}
                  style={{ height: "200px", width: "280px", margin: "auto" }}
                  image={this.logoUrl}
                //title="logo"
                /> */}

                  <ResponsiveImgMaterialUi //style={{ width: "150px", padding: "1em 0px" }}
                  style={{ width: '250px'  }}
                  //xs={require('app/assets/logo-kulinarne-pysznosci.png').default}
                  //md={require('app/assets/logo-kulinarne-pysznosci.png').default}
                  //lg={require('app/assets/logo-kulinarne-pysznosci.png').default}
                  xs={this.logoUrl}
                  md={this.logoUrl}
                  lg={this.logoUrl}
                />

              </DialogContent>
              <DialogActions >
                <Button onClick={() => this.closeDialogStatus()} variant="outlined" size="small" color="primary"
                  style={{ fontSize: "0.8rem" }}
                >
                  <b><Trans>OK</Trans></b>
                </Button>
              </DialogActions>
            </Dialog> : null}


          {/* ///////////////////////////////////////////////////////////////////////////////     */}  
          <div style={{display: this.props.page.displayWindow === DisplayWindow.Map || this.props.page.displayWindow === DisplayWindow.History? "none" : "contents"}}> 
            <Grid item xs={12} sm={3} md={2} className={`${classes.leftPanel} ${classes.panels}`} >
              <div className={classes.leftPanelInner} style={CONFIG.kelnerBookFoto === "2" || CONFIG.kelnerBookFoto === "3" ?{position: "sticky", zIndex: '1', top: "29px"} : {}}>
                <PanelLeftTest />
                {this.state.width <= mobileBreakpoint ?
                  null :

                  <CardMedia
                    style={{width: "150px", margin: "1em auto auto" }}
                    image={this.grafikaUrl}
                    
                  //title="logo"
                  component="img"
                  onError={(event: any) => event.target.style.display = 'none'}
                  />
                  
                  }
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={8}
              className={`${classes.panels}`} style={{marginBottom: this.state.width > 599 ? 0 : '1.5em'}}>
              {this.selectComponent()}

              {this.state.width > 599 ?
              <LogoFooter/> : null}
                            
            </Grid>
            <Grid item xs={12} sm={3} md={2} className={`${classes.rightPanel} ${classes.panels}`} classes={{ "grid-xs-12": classes.xs12 }}>
              <div style={CONFIG.kelnerBookFoto === "2" || CONFIG.kelnerBookFoto === "3" ?{position: "sticky", top: "29px"} : {}}>
                <PanelRightBasket />
                <PanelRight/>

                {this.state.width <= 599 ?
                  <LogoFooter/> : null}
                
              </div>
            </Grid>
          </div> 

              {/* ///////////////////////////////////////////////////////////////////////////////     */}
            
              {this.props.page.displayWindow === DisplayWindow.Map? 
          <>
          <Paper id="graphic" className={classes.paper} elevation={0} >
          <MapContainer />
          </Paper>
          <Fab
              color="primary"
              aria-label="map"
              onClick={() =>  store.dispatch(Actions.pageState.setDisplayWindow(DisplayWindow.Main)) }
              style={{ height: "40px" }}
              className={classes.fab}
            >
              <Typography style={{ textTransform: "none", fontSize: "14px", color: "white" }}>
                {"wróć"}
              </Typography>
            </Fab>
          </> : null }
          {/* ///////////////////////////////////////////////////////////////////////////////     */}
          {this.props.page.displayWindow === DisplayWindow.History? 
          <>
            <Main/>
          </>
          :null}

          <Success open={this.state.openSuccess} handleModalClose={this.closeWindows} />
          <Failure open={this.state.openFailure} handleModalClose={this.closeWindows} />
        </Grid>
      )
    }
  }
}

// połączenie z Redux
const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
});

const styles = (theme: Theme) => ({
  container: {
    margin: "0em auto",
    paddingTop: "2em",
    padding: '0em',
    width: "100%",
    maxWidth: "1340px"
  },
  grid: {
    paddingLeft: "3em",
    paddingRight: "3em"
  },
  grid1: {
    //padding: "inherit"
  },
  leftPanel: {
    //paddingTop: '2px!important'
  },
  rightPanel: {
    //paddingTop: '2px!important'
  },
  leftPanelInner: {
    width: '100%',
    //marginLeft:"0.5em",
    //marginRight:"0.5em",  
  },
  panels: {
    marginBottom: '1.5em',
    paddingLeft: "1.2em",
    paddingRight: "1.2em"
  },
  xs12: {
    //paddingRight: "20px"
  },
  dialog: {
    //maxWidth: "600px",
    [theme.breakpoints.down('xs')]: {
      maxwidth: "90vh"
    }
  },
  image: {
    // height: "400px",
    // width: "400px",
    margin: "auto",
    // [theme.breakpoints.down('xs')]: {
    //   height: "280px",
    //   width: "280px",
    // }
  },
  fab: {
    zIndex: 1000,
    position: "fixed" as "fixed",
    bottom: "15px",
    right: "15px",
  },
  paper: {
    background: "#fcfcfc",
    borderRadius: 0,
  },

});

//withStyles(styles)(Booking))
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Booking)));
